import React from "react";
import { remove, differenceBy, uniq } from "lodash";

function onSelect(e, item, selectedList, form, formField, change, fromNetwork) {
  if (e.target.checked) {
    const totalList = [...selectedList, item];
    if (fromNetwork) {
      change(formField, totalList);
      return;
    }
    change(form, formField, totalList);
  } else {
    remove(selectedList, { id: item.id });
    if (fromNetwork) {
      change(formField, selectedList);
      return;
    }
    change(form, formField, selectedList);
  }
}
function onSelectAll(
  e,
  selectedItems,
  totalItems,
  form,
  formField,
  change,
  fromNetwork
) {
  if (e.target.checked) {
    const uniqueTotalItems = uniq([...selectedItems, ...totalItems]);
    if (fromNetwork) {
      change(formField, uniqueTotalItems);
      return;
    }
    change(form, formField, uniqueTotalItems);
  } else {
    const formattedItem = differenceBy(selectedItems, totalItems, "id");
    if (fromNetwork) {
      change(formField, formattedItem);
      return;
    }
    change(form, formField, formattedItem);
  }
}

export const CustomCheckBox = ({
  item,
  selectedList,
  form,
  formField,
  change,
  fromNetwork = false
}) => (
  <label
    htmlFor={`checkbox-${item.id}`}
    className="contentSection__checkBoxWrapper"
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <input
      type="checkbox"
      id={`checkbox-${item.id}`}
      onClick={e => {
        e.stopPropagation();
        onSelect(e, item, selectedList, form, formField, change, fromNetwork);
      }}
      checked={selectedList.filter(i => i.id === item.id).length > 0}
    />
    <span className="checkmark checkmark--grid" />
  </label>
);

export const CustomHeaderCheckBox = ({
  page,
  selectedItems,
  totalItems,
  perPage,
  change,
  form,
  formField,
  fromNetwork = false
}) => (
  <div
    className="iconButton  iconButton--grid-select"
    id={`wrapper-${page}`}
    key={`key-wrapper-${page}`}
  >
    <label
      htmlFor={`checkbox-header-${page}`}
      className="contentSection__checkBoxWrapper"
    >
      <input
        type="checkbox"
        id={`checkbox-header-${page}`}
        onClick={e => {
          onSelectAll(
            e,
            selectedItems,
            totalItems,
            form,
            formField,
            change,
            fromNetwork
          );
        }}
        checked={
          selectedItems.filter(val => totalItems.some(i => i.id === val.id))
            .length === totalItems.length
        }
      />
      <span
        className="checkmark checkmark--select-all"
        id={`checkmark-${page}`}
      />
      <span className="ml-4">Select All</span>
    </label>
  </div>
);
